import { useState } from 'react'

import { Alert, Box, Button } from 'app/components/design-system-components'
import { Text } from 'app/components/design-system-components/typography'
import theme from 'app/match/applicationReportPDF/assets/theme'

interface ExpandableAlertBoxProps {
  expandable?: boolean
  heading?: string
  nonExpandContent?: JSX.Element
  expandContent?: JSX.Element
}

const ExpandableAlertBox = ({
  expandable = false,
  heading = 'Important Information',
  nonExpandContent,
  expandContent,
}: ExpandableAlertBoxProps) => {
  const [isExpanded, setIsExpanded] = useState(false)

  const toggleExpand = () => {
    setIsExpanded(!isExpanded)
  }

  return (
    <Alert variant="blueWithBg" mb={8} height="100%">
      <Box color="deepBlue">
        <Text
          fontSize={theme.fontSizes.pRegular14}
          color="deepBlue"
          fontWeight="bold"
          mb={5}
        >
          {heading}
        </Text>

        <Text fontSize={theme.fontSizes.pRegular14} color="deepBlue" mb={5}>
          {nonExpandContent}
        </Text>

        {expandable && !isExpanded && (
          <Button
            variant="linkBlueUnderlinedWithHoverBold"
            onClick={toggleExpand}
          >
            see more
          </Button>
        )}

        {(!expandable || isExpanded) && <>{expandContent}</>}

        {expandable && isExpanded && (
          <Button
            variant="linkBlueUnderlinedWithHoverBold"
            onClick={toggleExpand}
          >
            see less
          </Button>
        )}
      </Box>
    </Alert>
  )
}

export default ExpandableAlertBox
